import React from "react";
import "./TabsHolder.css";
import { AiOutlineClose } from "react-icons/ai";
import { TbFileInvoice } from "react-icons/tb";

/**
 * Props
 * - tabs: [{ id, title, icon?, unsaved? }]
 * - activeId: string
 * - onTabClick: (id) => void
 * - onCloseTab: (id) => void
 */
export default function TabsHolder({
  tabs = [],
  activeId,
  onTabClick,
  onCloseTab,
}) {
  return (
    <nav className="tabs-nav" style={{width:'100%', borderBottom:'0.5px solid var(--api-option-active-color)',paddingBottom:'5px'}}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`tab ${activeId === tab.id ? "selected-tab" : ""}`}
          onClick={() => onTabClick?.(tab.id)}
          onMouseDown={(e) => {
            // Middle click -> kapat
            if (e.button === 1) {
              e.preventDefault();
              onCloseTab?.(tab.id);
            }
          }}
          title={tab.title}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "5px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {tab.icon ?? <TbFileInvoice style={{ minWidth: 20, width: 20 }} size={20} />}
            <span>
              {tab.title}
              {tab.unsaved ? <span className="unsaved-dot"> •</span> : null}
            </span>
          </div>

          <AiOutlineClose
            className="close-icon"
            onClick={(e) => {
              e.stopPropagation();
              onCloseTab?.(tab.id);
            }}
          />
        </div>
      ))}
      {/* Not: İstenmediği için "+" yok */}
    </nav>
  );
}